export default __webpack_public_path__ + "static/media/gameOver2.b2c6a3aa.mp3";